import dayjs from "dayjs";
import { User } from "../../../states/user";
import { MainProfileImg } from "../../atoms/MainProfileImg";
import * as S from "./mainProfile.styles";
import { MainChartContents } from "../MainChartContents";
import { TransportationPerformanceType } from "../../../interface/transportation";

interface MainProfileProps {
  count: number;
  user: User | null;
  performanceData?: TransportationPerformanceType;
}

export const MainProfile = ({
  count,
  user,
  performanceData,
}: MainProfileProps) => {
  return (
    <>
      <S.MainProfileSection>
        <S.MainProfileBox>
          {!user?.profileImg ? (
            <MainProfileImg width={70} height={70} />
          ) : (
            <S.MainProfile>
              <img
                src={`${process.env.REACT_APP_API_HOST}${user.profileImg.imageUrl}`}
                alt="profile"
              />
            </S.MainProfile>
          )}
          <S.ProfileTxtBox>
            <S.UserStatusBox>
              <S.UserAuthSpan>기사회원</S.UserAuthSpan>
              <div>
                이번 달 총 <span>{count} 건</span>의 운송을
                <br />
                완료하셨습니다.
              </div>
            </S.UserStatusBox>
            <S.ProfileDate>
              {dayjs(new Date()).format("YYYY-MM-DD HH:mm")} 기준
            </S.ProfileDate>
          </S.ProfileTxtBox>
        </S.MainProfileBox>

        {/* 운송실적 원형차트 */}
        <MainChartContents performanceData={performanceData} />
      </S.MainProfileSection>
    </>
  );
};
